import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const invoicebuyerApi = createApi({
  reducerPath: "invoicebuyerApi",
  baseQuery,
  tagTypes: ["invoiceBuyer", "Currency"],
  endpoints: (builder) => ({

    // 🔹 Get invoice by master id
    getInvoiceBuyerByMasterId: builder.query({
      query: ({ id }) => `export/invoice/main/${id}`,
      transformResponse: (response) => response?.data ?? [],
      providesTags: ["invoiceBuyer"],
    }),

    // 🔹 Get single buyer by id & subId
    getInvoiceBuyerById: builder.query({
      query: ({ id, subId }) => 
        `export/invoice/buyer-third-party/${id}/${subId}`,
      transformResponse: (response) => {
        return response?.data ?? null;
      },
      providesTags: ["invoiceBuyer"],
    }),

    // 🔹 Update buyer
    updateInvoiceBuyer: builder.mutation({
      query: ({ id, dataId, ...data }) => ({
        url: `export/invoice/buyer-third-party/${id}/${dataId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { buyerThirdParty: data },
      }),
      invalidatesTags: ["invoiceBuyer"],
    }),

  }),
});

// 🔹 Export generated hooks
export const {
  useGetInvoiceBuyerByMasterIdQuery,
  useGetInvoiceBuyerByIdQuery,
  useLazyGetInvoiceBuyerByIdQuery,
  useUpdateInvoiceBuyerMutation,
} = invoicebuyerApi;
